module.exports = __webpack_public_path__ + "static/media/Relative-Faux-Web.93725e24.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Relative-Faux-Web.woff
// module id = 736
// module chunks = 0